import firebase from 'firebase'

let config = {
    apiKey: "AIzaSyBbc9DAgsvXw4HI6coZoOYeNWB2t1Q3tzY",
    authDomain: "kartojn.firebaseapp.com",
    databaseURL: "https://kartojn.firebaseio.com",
    projectId: "kartojn",
    storageBucket: "kartojn.appspot.com",
    messagingSenderId: "197189019983"
};

let firebase_connection = firebase.initializeApp(config);
export default firebase_connection;


// WEBPACK FOOTER //
// ./src/backend/firebase.js